module.exports = __webpack_public_path__ + "static/media/floating_teacher.e5da0874.png";